var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#16449A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_685_2022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4639 10.4981C26.2133 9.51484 25.4724 8.74065 24.533 8.47742C22.8303 8 16 8 16 8C16 8 9.16962 8 7.46699 8.47742C6.52757 8.74065 5.78671 9.51484 5.53603 10.4981C5.07935 12.2813 5.07935 16 5.07935 16C5.07935 16 5.07935 19.7187 5.53603 21.5019C5.78671 22.4852 6.52757 23.2594 7.46699 23.5226C9.16962 24 16 24 16 24C16 24 22.8303 24 24.533 23.5226C25.4724 23.2594 26.2133 22.4852 26.4639 21.5019C26.9206 19.7187 26.9206 16 26.9206 16C26.9206 16 26.9206 12.2813 26.4639 10.4981Z",
    fill: "#ECF0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7661 19.3766L19.4746 15.9998L13.7661 12.623V19.3766Z",
    fill: "#16449A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_685_2022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8413,
    height: 16,
    fill: "white",
    transform: "translate(5.07935 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c0247aae06587d6234e10613ed9c827d.svg";
export { ForwardRef as ReactComponent };